import { makeAutoObservable } from 'mobx';
import axios from 'axios';

export class AppConfigStore {
  taxRate = 0.1;

  constructor() {
    makeAutoObservable(this);
    this.fetchConfig();
  }

  private async fetchConfig() {
    try {
      const response = await axios.get('/api/v1/config');
      if (response.data?.taxRate != null) {
        this.taxRate = response.data.taxRate;
      }
    } catch (error) {
      console.error('Failed to fetch app config:', error);
    }
  }
}
